module.exports = function (api) {
  if (typeof global !== 'undefined') {
    global.cssx = api;
  }
  if (typeof window !== 'undefined') {
    window.cssx = api;
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./packages/cssx/src/helpers/goGlobal.js
 ** module id = 18
 ** module chunks = 0
 **/